"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Pexeso = exports.Mines = exports.Sokoban = exports.Tetris = undefined;

var _Tetris2 = require("./tetris/Tetris");

var _Tetris3 = _interopRequireDefault(_Tetris2);

var _Sokoban2 = require("./sokoban/Sokoban");

var _Sokoban3 = _interopRequireDefault(_Sokoban2);

var _Mines2 = require("./mines/Mines");

var _Mines3 = _interopRequireDefault(_Mines2);

var _Pexeso2 = require("./pexeso/Pexeso");

var _Pexeso3 = _interopRequireDefault(_Pexeso2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Tetris = _Tetris3.default;
exports.Sokoban = _Sokoban3.default;
exports.Mines = _Mines3.default;
exports.Pexeso = _Pexeso3.default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvZ2FtZXMvaW5kZXguanN4Il0sIm5hbWVzIjpbIlRldHJpcyIsIlNva29iYW4iLCJNaW5lcyIsIlBleGVzbyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztRQUFPQSxNO1FBQ0FDLE87UUFDQUMsSztRQUNBQyxNIiwiZmlsZSI6ImluZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IFRldHJpcyBmcm9tIFwiLi90ZXRyaXMvVGV0cmlzXCI7XG5leHBvcnQgU29rb2JhbiBmcm9tIFwiLi9zb2tvYmFuL1Nva29iYW5cIjtcbmV4cG9ydCBNaW5lcyBmcm9tIFwiLi9taW5lcy9NaW5lc1wiO1xuZXhwb3J0IFBleGVzbyBmcm9tIFwiLi9wZXhlc28vUGV4ZXNvXCI7XG4iXX0=